const $ = window.$;
// JQuery.
// NOTE: Refactor this if jQuery is no longer used on xertonline.
export default function notify(data){
    
    if (data.timeout === undefined)
    data.timeout = 3000;

    const icons = {
        danger: 'fa fa-warning',
        success: 'fa fa-check'
    }
    
    $.notify({
        icon: icons[data.level],
        message: data.message,
        url: data.url
    }, {
        type: data.level,
        delay: data.timeout,
        placement: {
            from: "top",
            align: "center"
        }
    });
}